require('datatables.net')(window, $);
require('datatables.net-bs5')(window, $);
require('datatables.net-plugins/sorting/datetime-moment');

